import { REDUCER_KEY, LOGS, TERMS } from './constants';

export const getLogs = state => state[REDUCER_KEY][LOGS] || {};
export const getTerms = state => state[REDUCER_KEY][TERMS] || {};
